import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"
import { patch } from "@rails/request.js"

export default class extends Controller {
  static values = { url: String, handle: { type: String, default: ".drag-handle, .block-drag-handle, .block-handle" } }

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: this.handleValue,
      animation: 150,
      ghostClass: "sortable-ghost",
      chosenClass: "sortable-chosen",
      onEnd: this.onEnd.bind(this)
    })
  }

  disconnect() {
    this.sortable.destroy()
  }

  async onEnd(event) {
    // Support both data-sortable-id and data-block-id
    const id = event.item.dataset.sortableId || event.item.dataset.blockId ||
               event.item.querySelector("[data-block-id]")?.dataset.blockId
    const position = event.newIndex

    if (!id) return

    const url = this.urlValue.replace(":id", id)

    await patch(url, {
      body: JSON.stringify({ position: position }),
      headers: {
        "Content-Type": "application/json"
      }
    })
  }
}
